var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Layout',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('div',{staticClass:"aside"},[_c('SiteAside')],1)]},proxy:true},{key:"main",fn:function(){return [_c('div',{staticClass:"main"},[_c('RouterView')],1)]},proxy:true}])}),_c('Totop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }